module.exports = __webpack_public_path__ + "img/beine-seite-outline-R.0a7f4a66.png";